import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {StoreInformation} from "../types/StoreInformation";

export const useStoreInformation = (dealerId: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ee-pro-store', dealerId],
        queryFn: async () => await apiClient.get('ee-pro/store-information?dealerID=' + dealerId) as StoreInformation,
        enabled: dealerId > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || {} as StoreInformation,
        isLoading: isLoading
    };
};
